import React from "react";
import { Helmet } from "react-helmet-async";
import "./css/BioPage.css"; // create this for styling or inline styles
import TodImg from './images/band/tod_tugboat.webp';
import PhotoGallery from './sub-components/PhotGallery';
import JayImg from './images/band/jay_captain_riff.webp';
import DeanImg from './images/band/dean_deckhand.webp';
import HaijungImg from './images/band/haijung_choi.webp';
import MikeImg from './images/band/michael_keys.webp';
import GaryImg from './images/band/gary_anchor.webp';

// Keep these in sync with the "/BioPage" entry in SeoPageRenderer.cs
const PAGE_URL = "https://www.dysband.com/BioPage";
const PAGE_TITLE = "Meet the Dirty Yachtin' Scoundrels | Band Bios & Members";
const PAGE_DESCRIPTION =
    "Get to know the yacht rock band Dirty Yachtin' Scoundrels. Meet the talented musicians behind the smooth '70s and '80s hits you love.";
const PAGE_IMAGE =
    "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp";

const bandMembers = [
    {
        name: "Tod Miller",
        role: "Lead Vocalist",
        bio: "With a voice as smooth as the ocean breeze, Tod brings passion and vocal talent that defines the Dirty Yachtin' Scoundrels sound.",
        photo: TodImg,
    },
    {
        name: "Jay Poole",
        role: "Guitar & Backup Vocals",
        bio: "Jay brings energy, charisma, and a great musical presence to the stage, helping keep the yacht rock vibe alive and the crowd engaged.",
        photo: JayImg,
    },
    {
        name: "Dean Miller",
        role: "Guitar & Backup Vocals",
        bio: "Dean brings a smooth, confident style and plenty of stage presence, helping deliver the timeless sound and laid-back vibe of yacht rock.",
        photo: DeanImg,
    },
    {
        name: "Haijung Choi",
        role: "Bass Guitar & Backup Vocals",
        bio: "Haijung lays down the foundation with deep bass lines and contributes rich vocal harmonies that make the band’s sound truly full.",
        photo: HaijungImg,
    },
    {
        name: "Gary Sanchez",
        role: "Drums & Percussion",
        bio: "Gary keeps the rhythm steady and dynamic, powering the band with tight percussion that drives the yacht rock feel.",
        photo: GaryImg,
    },
    {
        name: "Michael Berrelleza",
        role: "Keyboards",
        bio: "Michael adds the signature smooth yacht rock textures with his versatile keyboard playing and musical creativity.",
        photo: MikeImg,
    },
];


const BioPage = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "MusicGroup",
        "name": "Dirty Yachtin' Scoundrels",
        "member": bandMembers.map(({ name, role }) => ({
            "@type": "Person",
            "name": name,
            "jobTitle": role,
        })),
    };
    return (
        <>
            <section className="bio-page container">
                <Helmet>
                    <title>{PAGE_TITLE}</title>
                    <meta name="description" content={PAGE_DESCRIPTION} />
                    <link rel="canonical" href={PAGE_URL} />

                    {/* Open Graph */}
                    <meta property="og:title" content={PAGE_TITLE} />
                    <meta property="og:description" content={PAGE_DESCRIPTION} />
                    <meta property="og:image" content={PAGE_IMAGE} />
                    <meta property="og:url" content={PAGE_URL} />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />

                    {/* Twitter */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={PAGE_TITLE} />
                    <meta name="twitter:description" content={PAGE_DESCRIPTION} />
                    <meta name="twitter:image" content={PAGE_IMAGE} />

                    {/* Structured Data for SEO */}
                    <script type="application/ld+json">{JSON.stringify(schema)}</script>
                </Helmet>

                <h1>Meet the Dirty Yachtin' Scoundrels</h1>
                <p>
                    The Dirty Yachtin' Scoundrels are a talented crew of musicians delivering the smoothest yacht rock
                    vibes. Get to know the faces and stories behind the music.
                </p>

                <div className="band-members">
                    {bandMembers.map(({ name, role, bio, photo }) => (
                        <div className="member-card" key={name}>
                            <img src={photo} alt={`Photo of ${name}`} className="member-photo" />
                            <h2>{name}</h2>
                            <h3>{role}</h3>
                            <p>{bio}</p>
                        </div>
                    ))}
                </div>

            </section>
            <PhotoGallery />
        </>
    );
};

export default BioPage;